import { styled } from "@mui/material/styles";

const Heading = styled("h3")({
  fontWeight: 500,
  fontSize: 24,
  textAlign: "center",
  margin: 0,
});

const Guide = styled("p")({
  textAlign: "center",
  margin: 0,
});

export { Heading, Guide };
